import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";
import type { GridConfig } from "@/types/api";

export function useGrids() {
  return useQuery<GridConfig[]>({
    queryKey: ["grids"],
    queryFn: () => apiGet<GridConfig[]>("/grids"),
    // SSE pushes invalidation; keep a 30s safety-net poll.
    refetchInterval: 30_000,
  });
}
